// 泛型狀態機 — 取代 Unity 第三方 StateMachine<T>。
// 狀態以 enter/update/exit 三個可選回呼定義；update 由遊戲迴圈每幀驅動。

export interface StateHandlers {
  enter?: () => void
  update?: (deltaSeconds: number) => void
  exit?: () => void
}

export class StateMachine<S extends string | number> {
  private readonly states = new Map<S, StateHandlers>()
  private currentState: S | null = null
  private readonly onChange: ((from: S | null, to: S) => void) | undefined

  constructor(onChange?: (from: S | null, to: S) => void) {
    this.onChange = onChange
  }

  define(state: S, handlers: StateHandlers): this {
    this.states.set(state, handlers)
    return this
  }

  change(state: S): void {
    if (state === this.currentState) return
    const previous = this.currentState
    if (previous !== null) {
      this.states.get(previous)?.exit?.()
    }
    this.currentState = state
    this.onChange?.(previous, state)
    this.states.get(state)?.enter?.()
  }

  update(deltaSeconds: number): void {
    if (this.currentState === null) return
    this.states.get(this.currentState)?.update?.(deltaSeconds)
  }

  get state(): S | null {
    return this.currentState
  }

  is(state: S): boolean {
    return this.currentState === state
  }
}
